export const TITLE = "Salarymates";
export const DESCRIPTION = "DESCRIPTION";
export const ADDRESS = "Floor No: Second Floor, Building No: 87/E, Road/Street: Model Town, Nearby Landmark: Near Jindal Chownk, City/Town/Village: Hisar, State: Haryana, PIN Code: 125001";
export const EMAIL = "support@salarymates.com";
export const PHONE = "+91- 9034006418 ";
